declare var swal: any;
import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { SpinnerService } from '../../../services/spinner.service';
import { AppData } from '../../../models/appdata';
import { ApiResponseModel } from '../../../models/api_response_model';
import { HCPService } from '../../../services/hcp.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ActorPersonalDetailInfoRequest, ActorPersonalDetailInfoController, ActorContactInfoController, ActorContactInfoRequest } from '../../../models/profileinfo/profileinfo.model';
import { ActorImageController, OTFormsByFormattedCodeController, OTFormDetailByReportCodeRequest, OTFormsByFormattedCodeRequest, OTFormDetailByReportCodeController, SectionData, FormOrganizer, X_BillHeaderController, x_BillDetailsRequest, BillDetailsInfoController, X_BillItemsController, X_BillReceiptsController, GenerateIahOrderFromBillRequest, TreatmentCyclesController, TreatmentCyclesRequest } from '../../../models/actor/actor';
//import { NgxMaskModule } from 'ngx-mask';
import * as alertFunctions from '../../../../shared/data/sweet-alerts';
import { CustomDateTimeService } from '../../../services/datetime.service';
//import './profilesteps.js';
//declare var mess1: any;
//declare var stepObject: any;
//declare var pSteps: any;
//declare var webGlObject: any;

import { NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { NgbDateParserFormatter, NgbTimeStruct } from '@ng-bootstrap/ng-bootstrap';
import { NGXToastrService } from '../../../../shared/services/toastr.service';
import { ActorService } from '../../../../../../src/app/ncs/services/actor.service';


import { PrintService } from '../../../../../../src/app/ncs/services/print.service';


import { NgxSpinnerService } from 'ngx-spinner';
import { NgbAddbilladv } from './modal/addbilladv.modal';
import { NgbSearchPatientModal } from '../follow up/counsellingregistry/modal/searchpatient.modal';
import { NgbNewCycleModal } from '../ivf/ivfdashboard/newcycle.modal';
import { NgbUpdateCycleStatusModal } from '../ivf/ivfdashboard/updatecyclestatus.modal';
@Component({
    selector: 'cyclesprofile',
  templateUrl: './cyclesprofile.component.html',
  styleUrls: ['./cyclesprofile.component.scss']
})

export class CyclesProfileComponent implements OnInit {

    @Input() ActorCode: number;
    @Input() ActorType: number;
    @Input() FormattedCode: string;
    @Input() CanEdit: number;
    @Input() CanShow: number;
    @Input() PatientCode: number;

    public isRequesting: boolean = false;

    public BillsList: boolean = true;
    public BillsDetails: boolean = false;
    public ApiResData: ApiResponseModel;

    public MaxDateV = new Date();  
    public MinDateV = new Date();
    public PatientFormattedCode: string;
    public PatientName: string;
    public PayeeName: string;
    public Toatalbill: number;
    public PaidBill: number;
    DOB: NgbDateStruct;

    CurrentGenerateIahOrderFromBillRequest: GenerateIahOrderFromBillRequest;

    maxDate: NgbDateStruct;
    minDate: NgbDateStruct;

    //
  public key: ActorPersonalDetailInfoController;
  

    @Input()
    get Key() {
        return this.key;
    }

    @Output() personalInfoChange = new EventEmitter();
    public ChargeEntryCode: number;
    CurrentTreatmentCyclesController: TreatmentCyclesController[];
    CurrentTreatmentCyclesRequest: TreatmentCyclesRequest;
    LoadPatients() {
        this.CurrentTreatmentCyclesRequest = new TreatmentCyclesRequest();
        //this.CurrentTreatmentCyclesRequest.FormattedCode = "GG1O/577";
       // this.CurrentTreatmentCyclesRequest.Branch = 0;
        this.CurrentTreatmentCyclesRequest.ConditionalOperator = 20;
        //this.CurrentTreatmentCyclesRequest.FromDate = new Date();
        //this.CurrentTreatmentCyclesRequest.ToDate = new Date();
        this.CurrentTreatmentCyclesRequest.ActorCode = this.ActorCode;
        //this.CurrentTreatmentCyclesRequest.CycleCode = 0;
        //this.CurrentTreatmentCyclesRequest.From = 0;
        //this.CurrentTreatmentCyclesRequest.Status = "";
        //this.CurrentTreatmentCyclesRequest.SearchText = "";
        this.CurrentTreatmentCyclesRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
        this.GetTreatmentCyclesController();
    }
    GetTreatmentCyclesController() {
        this.StartRefreshing();


        this.actorservice.GetTreatmentCyclesController(this.CurrentTreatmentCyclesRequest)
            .subscribe((result) => {
                this.ApiResData = result;
                if (!this.ApiResData.hasError) {

                    this.CurrentTreatmentCyclesController = this.ApiResData.Result;
                    //  this.SelectedService = this.CurrentServiceDetailsByCodeController[0];
                    //alert(this.CurrentServiceDetailsByCodeController[0].CategoryName);
                    //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.ActorCode.toString();
                    this.stopRefreshing();

                }
                else {
                    this.stopRefreshing();
                    if (this.ApiResData.ErrorData != "") {

                        alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
                    }
                    else {
                        alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
                    }
                }

            },


                (error) => {

                    if (error == "401 - Unauthorized") {
                        alertFunctions.AlertParamEr(error);
                        this.stopRefreshing();



                    }
                    else {
                        alertFunctions.AlertParamEr(error);
                        this.stopRefreshing();
                    }
                }


            );
    }
  constructor(private router: Router,
        public printService: PrintService,
        private route: ActivatedRoute, private loaderService: SpinnerService, private hcpservice: HCPService, private actorservice: ActorService,
        private modalService: NgbModal, private customdatetimeservice: CustomDateTimeService,
      private parserFormatter: NgbDateParserFormatter, private spinner: NgxSpinnerService, private tosterservice: NGXToastrService) {
        //stepObject.init();
    }

    ngOnInit() {
        
        this.PatientFormattedCode = this.FormattedCode;
        this.CurrentGenerateIahOrderFromBillRequest = new GenerateIahOrderFromBillRequest();
        this.CurrentGenerateIahOrderFromBillRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
        this.LoadPatients();

    }

    //ViewPatientDetails() {
    //    this.BillsList = false;
    //    this.BillsDetails = true;
    //    this.LoadBillHeader();
    //    this.LoadBillItems();
    //    this.LoadBillReceipts();
    //}
    SelectedpatientDetails: X_BillHeaderController;
    Selectedpatient(objCategory: any) {
        var patient: X_BillHeaderController = objCategory;
        if (patient != null) {
            //alert(patient.ChargeEntry);
            this.SelectedpatientDetails = null;
            this.SelectedpatientDetails = patient;
            this.BillsList = false;
            this.BillsDetails = true;
           // this.billdetails1 = true;
            //this.billdetails2 = true;
            this.LoadBillHeader();
            this.LoadBillItems();
            this.LoadBillReceipts();
        }


    }
    CurrentX_BillHeaderController: X_BillHeaderController;
    //FollicularScanEndInfo: FollicularScanDetailController;
    // BillHeader: X_BillHeaderController[];
    CurrentX_BillHeaderRequest: x_BillDetailsRequest;

    BillDataHeader: BillDetailsInfoController;

    LoadBillHeader() {
        //alert("ScansData")
        this.CurrentX_BillHeaderRequest = new x_BillDetailsRequest();
        //this.CurrentFollicularScansBetweenDateController = new Array<FdActorReportsDocController>();
        //this.CurrentPatientInfoByFormattedCodeController = new PatientInfoByFormattedCodeController[0];
        //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode.toString();
        this.CurrentX_BillHeaderRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
        this.GetX_BillHeaderController();
    }

    GetX_BillHeaderController() {
        //this.StartRefreshing();

        this.CurrentX_BillHeaderRequest.ChargeEntry = this.SelectedpatientDetails.ChargeEntry;
        // alert(this.SelectedpatientDetails[0].Header[0].ChargeEntry);
        this.CurrentX_BillHeaderRequest.ConditionalOperator = 5;
        //this.Cu
        //alert(this.FormattedCode);

        this.actorservice.GetBillHeaderController(this.CurrentX_BillHeaderRequest)
            .subscribe((result) => {
                this.ApiResData = result;
                if (!this.ApiResData.hasError) {
                    //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode.toString();
                    this.BillDataHeader = this.ApiResData.Result;
                    this.CurrentX_BillHeaderController = this.BillDataHeader.Header;
                    //alert(this.CurrentX_BillHeaderController[0].PatientName);
                    //this.CurrentX_BillHeaderController = this.BillDataHeader.Header;
                    // this.CurrentX_BillHeaderController[0].PatientName;
                    //alert(this.CurrentX_BillHeaderController);
                    //this.BillHeader = this.CurrentX_BillHeaderController[0].PatientName;
                    //this.CurrentSaveFollicularScanDetailRequest.EndometriumThickness
                    //  = this.FollicularScanEndInfo.EndometriumThickness;
                    //this.CurrentSaveFollicularScanDetailRequest.Remarks = this.FollicularScanEndInfo.Comments;
                    //this.CurrentSaveFollicularScanDetailRequest.ScanDate = this.FollicularScanEndInfo.ScanDate;

                    //this.SelectedPatient = this.CurrentPatientInfoByFormattedCodeController[0];

                    //  this.SelectedService = this.CurrentServiceDetailsByCodeController[0];
                    //alert(this.CurrentServiceDetailsByCodeController[0].CategoryName);
                    //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode;

                    //this.stopRefreshing();
                    //   this.LoadGuardian();
                    //this.LoadMessages();


                }
                else {
                    this.stopRefreshing();
                    if (this.ApiResData.ErrorData != "") {

                        alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
                    }
                    else {
                        alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
                    }
                }

            },


                (error) => {

                    if (error == "401 - Unauthorized") {
                        alertFunctions.AlertParamEr(error);
                        this.stopRefreshing();



                    }
                    else {
                        alertFunctions.AlertParamEr(error);
                        this.stopRefreshing();
                    }
                }


            );
    }
    CurrentX_BillItemsController: X_BillItemsController[];
    //FollicularScanEndInfo: FollicularScanDetailController;
    //BillHeader: X_BillHeaderController[];
    CurrentX_BillItemsRequest: x_BillDetailsRequest;

    BillData: BillDetailsInfoController;

    LoadBillItems() {
        //alert("ScansData")
        this.CurrentX_BillItemsRequest = new x_BillDetailsRequest();
        //this.CurrentFollicularScansBetweenDateController = new Array<FdActorReportsDocController>();
        //this.CurrentPatientInfoByFormattedCodeController = new PatientInfoByFormattedCodeController[0];
        //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode.toString();
        this.CurrentX_BillItemsRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
        this.GetX_BillItemsController();
    }

    GetX_BillItemsController() {
        //this.StartRefreshing();

        this.CurrentX_BillItemsRequest.ChargeEntry = this.SelectedpatientDetails.ChargeEntry;
        // alert(this.SelectedpatientDetails[0].Header[0].ChargeEntry);
        this.CurrentX_BillItemsRequest.ConditionalOperator = 5;
        //this.Cu
        //alert(this.FormattedCode);

        this.actorservice.GetBillItemsController(this.CurrentX_BillItemsRequest)
            .subscribe((result) => {
                this.ApiResData = result;
                if (!this.ApiResData.hasError) {
                    //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode.toString();

                    this.BillData = this.ApiResData.Result;
                    this.CurrentX_BillItemsController = this.BillData.Items;

                    // this.CurrentX_BillHeaderController[0].PatientName;
                    //alert(this.CurrentX_BillHeaderController);
                    //this.BillHeader = this.CurrentX_BillHeaderController[0].PatientName;
                    //this.CurrentSaveFollicularScanDetailRequest.EndometriumThickness
                    //  = this.FollicularScanEndInfo.EndometriumThickness;
                    //this.CurrentSaveFollicularScanDetailRequest.Remarks = this.FollicularScanEndInfo.Comments;
                    //this.CurrentSaveFollicularScanDetailRequest.ScanDate = this.FollicularScanEndInfo.ScanDate;

                    //this.SelectedPatient = this.CurrentPatientInfoByFormattedCodeController[0];

                    //  this.SelectedService = this.CurrentServiceDetailsByCodeController[0];
                    //alert(this.CurrentServiceDetailsByCodeController[0].CategoryName);
                    //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode;

                    //this.stopRefreshing();
                    //   this.LoadGuardian();
                    //this.LoadMessages();


                }
                else {
                    this.stopRefreshing();
                    if (this.ApiResData.ErrorData != "") {

                        alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
                    }
                    else {
                        alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
                    }
                }

            },


                (error) => {

                    if (error == "401 - Unauthorized") {
                        alertFunctions.AlertParamEr(error);
                        this.stopRefreshing();



                    }
                    else {
                        alertFunctions.AlertParamEr(error);
                        this.stopRefreshing();
                    }
                }


            );
    }
   

    CurrentX_BillReceiptsController: X_BillReceiptsController[];

    CurrentX_BillReceiptsRequest: x_BillDetailsRequest;

    BillDataReceipt: BillDetailsInfoController;

    LoadBillReceipts() {
        //alert("ScansData")
        this.CurrentX_BillReceiptsRequest = new x_BillDetailsRequest();
        //this.CurrentFollicularScansBetweenDateController = new Array<FdActorReportsDocController>();
        //this.CurrentPatientInfoByFormattedCodeController = new PatientInfoByFormattedCodeController[0];
        //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode.toString();
        this.CurrentX_BillReceiptsRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
        this.GetX_BillReceiptsController();
    }

    GetX_BillReceiptsController() {
        //this.StartRefreshing();

        this.CurrentX_BillReceiptsRequest.ChargeEntry = this.SelectedpatientDetails.ChargeEntry;
        // alert(this.SelectedpatientDetails[0].Header[0].ChargeEntry);
        this.CurrentX_BillReceiptsRequest.ConditionalOperator = 5;
        //this.Cu
        //alert(this.FormattedCode);

        this.actorservice.GetBillReceiptsController(this.CurrentX_BillReceiptsRequest)
            .subscribe((result) => {
                this.ApiResData = result;
                if (!this.ApiResData.hasError) {
                    //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode.toString();

                    this.BillDataReceipt = this.ApiResData.Result;
                    this.CurrentX_BillReceiptsController = this.BillDataReceipt ? this.BillDataReceipt.Receipts : undefined;
                    if (this.CurrentX_BillReceiptsController && this.CurrentX_BillReceiptsController.length > 0) {
                      this.PatientName = this.CurrentX_BillReceiptsController[0].PatientName;
                      this.PayeeName = this.CurrentX_BillReceiptsController[0].PayeeName;
                      this.Toatalbill = this.CurrentX_BillReceiptsController[0].AmountPayable;
                      this.PaidBill = this.CurrentX_BillReceiptsController[0].AmountPaid;
                    }



                    // this.CurrentX_BillHeaderController[0].PatientName;
                    //alert(this.CurrentX_BillHeaderController);
                    //this.BillHeader = this.CurrentX_BillHeaderController[0].PatientName;
                    //this.CurrentSaveFollicularScanDetailRequest.EndometriumThickness
                    //  = this.FollicularScanEndInfo.EndometriumThickness;
                    //this.CurrentSaveFollicularScanDetailRequest.Remarks = this.FollicularScanEndInfo.Comments;
                    //this.CurrentSaveFollicularScanDetailRequest.ScanDate = this.FollicularScanEndInfo.ScanDate;

                    //this.SelectedPatient = this.CurrentPatientInfoByFormattedCodeController[0];

                    //  this.SelectedService = this.CurrentServiceDetailsByCodeController[0];
                    //alert(this.CurrentServiceDetailsByCodeController[0].CategoryName);
                    //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode;

                    //this.stopRefreshing();
                    //   this.LoadGuardian();
                    //this.LoadMessages();


                }
                else {
                    this.stopRefreshing();
                    if (this.ApiResData.ErrorData != "") {

                        alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
                    }
                    else {
                        alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
                    }
                }

            },


                (error) => {

                    if (error == "401 - Unauthorized") {
                        alertFunctions.AlertParamEr(error);
                        this.stopRefreshing();



                    }
                    else {
                        alertFunctions.AlertParamEr(error);
                        this.stopRefreshing();
                    }
                }


            );
    }
    //header() {
    //    let m = document.querySelector("#header");
    //    if (m) {
    //        m.scrollIntoView({ block: "center", inline: "nearest" });
    //    }
    //}
    items() {
        let m = document.querySelector("#items");
        if (m) {
            m.scrollIntoView({ block: "center", inline: "nearest" });
        }
    }
    Receipts() {
        let m = document.querySelector("#Receipts");
        if (m) {
            m.scrollIntoView({ block: "center", inline: "nearest" });
        }
    }
    BackToBillsList() {
        this.BillsList = true;
        this.BillsDetails = false;
    }
    billedit() {
        
        this.router.navigate(['healins/opbillingedit', { FormattedCodedata: this.FormattedCode }]);
    }
    SelectedPatient: TreatmentCyclesController;
    ViewPatientDetails(objCategory: any) {
        var patient: TreatmentCyclesController = objCategory;
        if (patient != null) {
            this.SelectedPatient = null;
            this.SelectedPatient = patient;

            this.router.navigate(['healins/treatmentcycle2', { ActorCode: this.SelectedPatient.ActorCode, CycleCode: this.SelectedPatient.Code, Duration: this.SelectedPatient.Duration, GradingModel: this.SelectedPatient.GradingModel, title: "Profile" }]);

        }
        else {

        }

    }
  AddNewBill() {

    this.router.navigate(['healins/receipt']);    
  }

    private stopRefreshing() {
        this.loaderService.displayLoader(false);
        this.isRequesting = false;
    }
    private StartRefreshing() {
        this.loaderService.displayLoader(true);
        this.isRequesting = true;
    }

    ConvertToIah() {
        //alert("Code");
        this.CurrentGenerateIahOrderFromBillRequest.ConditionalOperator = 10;
        this.CurrentGenerateIahOrderFromBillRequest.ChargeEntryCode = this.SelectedpatientDetails.ChargeEntry;
        this.actorservice.GenerateIahOrderFromBill(this.CurrentGenerateIahOrderFromBillRequest)
            .subscribe((result) => {
                this.ApiResData = result;
                if (!this.ApiResData.hasError) {

                    if (this.ApiResData.Result > 0) {
                        //this.GetActorEducationInfoController();
                        //this.GetResourceIdentificationByDateInfoController();
                        // alertFunctions.AlertParam('Saved Successfully.....!');
                        this.tosterservice.ToasterSuccessAlertParam('Saved Successfully.....!');

                        // this.Listview = true;
                        //this.EditEmbryo = false;
                        //this.LoadStoreData();
                        //this.AddEmbryo = false;
                        //this.spinner.hide();
                        //this.activeModal.close();
                        //this.clearData();
                        // this.LoadScansData();
                        this.stopRefreshing();
                        this.router.navigate(['healins/ConsumptionEntry']);
                    }
                    else {
                        alertFunctions.AlertParam("Invalid Operation...!");

                        //this.spinner.hide();
                        this.stopRefreshing();

                    }

                }
                else {
                    this.stopRefreshing();
                    if (this.ApiResData.ErrorData != "") {

                        //alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
                        alert(this.ApiResData.ErrorData);


                    }
                    else {
                        //this.spinner.hide();
                        this.stopRefreshing();
                        alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');

                    }
                }

            },


                (error) => {

                    if (error == "401 - Unauthorized") {
                        alertFunctions.AlertParamEr(error);
                        // this.spinner.hide();
                        this.stopRefreshing();



                    }
                    else {
                        alertFunctions.AlertParamEr(error);
                        // this.spinner.hide();
                        this.stopRefreshing();
                    }
                }
            );
    }
    SearchPatient() {
        const modalRef = this.modalService.open(NgbNewCycleModal,
            {
                centered: true,
                size: 'lg',
                backdrop: 'static',
                keyboard: false
            })
        modalRef.componentInstance.FormattedCode = this.FormattedCode;
        //modalRef.componentInstance.PatientName = val;
        //modalRef.componentInstance.PatientRegistrationNumber = val;
        modalRef.result.then(x => { this.GetTreatmentCyclesController() })
   
          

    }
    UpdateStatus(l: TreatmentCyclesController) {
        const modalRef = this.modalService.open(NgbUpdateCycleStatusModal,
            {
                centered: true,
                size: 'lg',
                backdrop: 'static',
                keyboard: false
            })
        modalRef.componentInstance.FormattedCode = l.PatientRegNo;
        modalRef.componentInstance.TreatmentCycleCode = l.Code;
    }

    opbill() {

    }
    Addbill() {
        this.router.navigate(['healins/receiptold', { FormattedCode: this.FormattedCode }]);
    }
    AddAdv() {
        const modalRef = this.modalService.open(NgbAddbilladv,
            {
                centered: true,
                size: 'lg',
                backdrop: 'static',
                keyboard: false
            })
        modalRef.componentInstance.FomattedCode = this.FormattedCode;
        modalRef.componentInstance.Type="FromProfile"
    }
}
